export const fmtEur = (n) =>
  new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("nl-NL", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return s;
  }
};

export const monthLabel = (period) => {
  if (!period) return "—";
  const [y, m] = period.split("-");
  const months = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];
  return `${months[parseInt(m, 10) - 1]} ${y}`;
};

export const LETTER_TYPES = {
  herinnering_vooraf: "Herinnering vooraf",
  herinnering_1: "1e Herinnering",
  herinnering_2: "2e Herinnering",
  aanmaning: "Aanmaning",
  algemeen: "Algemeen",
  wijziging: "Wijzigingsovereenkomst",
  overzicht: "Betalingsoverzicht",
  bevestiging: "Betalingsbevestiging",
  factuur: "Factuur",
};

export const COLOR = {
  green: "bg-emerald-100 text-emerald-700 hover:bg-emerald-100",
  orange: "bg-amber-100 text-amber-700 hover:bg-amber-100",
  red: "bg-red-100 text-red-700 hover:bg-red-100",
};
export const COLOR_LABEL = { green: "Actueel", orange: "Openstaand", red: "Te laat" };
export const DOT = { green: "bg-emerald-500", orange: "bg-amber-500", red: "bg-red-500" };

export const photoSrc = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};

export const normalizeNlPhone = (v) => {
  if (!v) return v;
  let s = String(v).replace(/[\s\-().]/g, "");
  if (s.startsWith("00")) s = "+" + s.slice(2);
  if (s.startsWith("06")) return "+316" + s.slice(2);
  if (s.startsWith("0")) return "+31" + s.slice(1);
  return s;
};

export const loanMonthly = (principal, annualRate, n) => {
  principal = Number(principal) || 0;
  n = Number(n) || 0;
  const r = (Number(annualRate) || 0) / 12 / 100;
  if (n <= 0) return 0;
  if (r === 0) return principal / n;
  return (principal * r) / (1 - Math.pow(1 + r, -n));
};
